import { motion } from "framer-motion";
import { useMemo } from "react";

// Colorful floating confetti pieces animated with CSS
export default function Confetti({ count = 30, dense = false }) {
  const pieces = useMemo(() => {
    const colors = ["#F0B91B", "#FFD700", "#E63946", "#FDFBF7", "#7FD1AE"];
    const total = dense ? count * 1.5 : count;
    return Array.from({ length: total }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 12,
      duration: 8 + Math.random() * 10,
      size: 6 + Math.random() * 10,
      color: colors[i % colors.length],
      shape: Math.random() > 0.5 ? "50%" : `${Math.random() * 30}%`,
      rotate: Math.random() * 360,
    }));
  }, [count, dense]);

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti"
          style={{
            left: `${p.left}%`,
            top: "-20px",
            width: p.size,
            height: p.size * 1.3,
            background: p.color,
            borderRadius: p.shape,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            transform: `rotate(${p.rotate}deg)`,
            boxShadow: `0 0 8px ${p.color}55`,
          }}
        />
      ))}
    </div>
  );
}

export function GoldStars({ count = 15 }) {
  const stars = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        top: Math.random() * 100,
        left: Math.random() * 100,
        delay: Math.random() * 3,
        size: 2 + Math.random() * 3,
      })),
    [count]
  );
  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      {stars.map((s) => (
        <motion.span
          key={s.id}
          animate={{ opacity: [0.2, 1, 0.2], scale: [1, 1.4, 1] }}
          transition={{
            duration: 2 + Math.random() * 2,
            repeat: Infinity,
            delay: s.delay,
          }}
          className="absolute rounded-full bg-[#F0B91B]"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: s.size,
            height: s.size,
            boxShadow: `0 0 ${s.size * 3}px #F0B91B`,
          }}
        />
      ))}
    </div>
  );
}
